export const BuildingIcon = ({
  size = 20,
}: {
  size?: number | string;
} = {}) => (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="20"
  //     height="20"
  //     viewBox="0 0 20 20"
  //     fill="none"
  //   >
  //     <path d="M20 20H0V0H20V20Z" stroke="#0B9DBD" />
  //     <path
  //       d="M15.0007 1.6665H5.00065C4.08018 1.6665 3.33398 2.4127 3.33398 3.33317V16.6665C3.33398 17.587 4.08018 18.3332 5.00065 18.3332H15.0007C15.9211 18.3332 16.6673 17.587 16.6673 16.6665V3.33317C16.6673 2.4127 15.9211 1.6665 15.0007 1.6665Z"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M8 18.3333V15H13V18.3333"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M6.66602 5H6.67435"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M13.334 5H13.3423"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M10 5H10.0083"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M10 8.3335H10.0083"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M10 11.6665H10.0083"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M13.334 8.3335H13.3423"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M13.334 11.6665H13.3423"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M6.66602 8.3335H6.67435"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //     <path
  //       d="M6.66602 11.6665H6.67435"
  //       stroke="#0B9DBD"
  //       stroke-width="1.66667"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //     />
  //   </svg>
  // );

  // export const LinkIcon = () => (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="16"
  //     height="16"
  //     viewBox="0 0 24 24"
  //     fill="none"
  //     stroke="#3e3e3e"
  //     stroke-width="2"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   >
  //     <path d="M10 13a5 5 0 0 0 7.07 0l3.54-3.54a5 5 0 0 0-7.07-7.07L10 5" />
  //     <path d="M14 11a5 5 0 0 0-7.07 0L3.39 14.54a5 5 0 0 0 7.07 7.07L14 19" />
  //   </svg>
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 1.66667H5C4.07953 1.66667 3.33333 2.41286 3.33333 3.33333V16.6667C3.33333 17.5871 4.07953 18.3333 5 18.3333H15C15.9205 18.3333 16.6667 17.5871 16.6667 16.6667V3.33333C16.6667 2.41286 15.9205 1.66667 15 1.66667Z"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M7.5 18.3333V15H12.5V18.3333"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M6.66667 5H6.675"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M13.3333 5H13.3417"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M10 5H10.0083"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M10 8.33333H10.0083"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M10 11.6667H10.0083"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M13.3333 8.33333H13.3417"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M13.3333 11.6667H13.3417"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M6.66667 8.33333H6.675"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M6.66667 11.6667H6.675"
      stroke="#0B9DBD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </svg>
);

// レジデンス用アイコン。BuildingIcon と同サイズ (size prop)・同色 (#0B9DBD)。
// 物件カテゴリ property_category === "residence" の物件で BuildingIcon の代わりに使う。
export const ResidenceIcon = ({
  size = 20,
  color = "#0B9DBD",
}: {
  size?: number | string;
  color?: string;
} = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="10 9 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke={color}
      strokeWidth={5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* 建物の外形 (切妻屋根) */}
      <path d="M48 13 L23 30 L23 82 L73 82 L73 30 Z" />
      {/* 2x2 の窓 (上部中央寄せ・間隔広め)。線は外形より少し細く。 */}
      <g strokeWidth={3.5}>
        <rect x="33" y="35" width="11" height="11" rx="2" />
        <rect x="52" y="35" width="11" height="11" rx="2" />
        <rect x="33" y="52" width="11" height="11" rx="2" />
        <rect x="52" y="52" width="11" height="11" rx="2" />
      </g>
      {/* 玄関 (下部中央・下開き)。線は外形より少し細く。 */}
      <path
        d="M41 82 L41 71 Q41 68 44 68 L52 68 Q55 68 55 71 L55 82"
        strokeWidth={4}
      />
    </g>
  </svg>
);

export const LinkIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.30775 17C1.80258 17 1.375 16.825 1.025 16.475C0.675 16.125 0.5 15.6974 0.5 15.1923V1.80775C0.5 1.30258 0.675 0.875 1.025 0.525C1.375 0.175 1.80258 0 2.30775 0H7.86525C8.07808 0 8.25633 0.0718332 8.4 0.2155C8.5435 0.359 8.61525 0.537167 8.61525 0.75C8.61525 0.962833 8.5435 1.141 8.4 1.2845C8.25633 1.42817 8.07808 1.5 7.86525 1.5H2.30775C2.23075 1.5 2.16025 1.53208 2.09625 1.59625C2.03208 1.66025 2 1.73075 2 1.80775V15.1923C2 15.2692 2.03208 15.3398 2.09625 15.4038C2.16025 15.4679 2.23075 15.5 2.30775 15.5H15.6923C15.7692 15.5 15.8398 15.4679 15.9038 15.4038C15.9679 15.3398 16 15.2692 16 15.1923V9.63475C16 9.42192 16.0718 9.24367 16.2155 9.1C16.359 8.9565 16.5372 8.88475 16.75 8.88475C16.9628 8.88475 17.141 8.9565 17.2845 9.1C17.4282 9.24367 17.5 9.42192 17.5 9.63475V15.1923C17.5 15.6974 17.325 16.125 16.975 16.475C16.625 16.825 16.1974 17 15.6923 17H2.30775ZM16 2.55375L7.24625 11.3077C7.10775 11.4461 6.93367 11.5169 6.724 11.5203C6.5145 11.5234 6.33725 11.4526 6.19225 11.3077C6.04742 11.1627 5.975 10.9871 5.975 10.7808C5.975 10.5744 6.04742 10.3988 6.19225 10.2537L14.9462 1.5H11.75C11.5372 1.5 11.359 1.42817 11.2155 1.2845C11.0718 1.141 11 0.962833 11 0.75C11 0.537167 11.0718 0.359 11.2155 0.2155C11.359 0.0718332 11.5372 0 11.75 0H16.596C16.8538 0 17.0689 0.0862494 17.2413 0.258749C17.4138 0.431083 17.5 0.646166 17.5 0.903999V5.75C17.5 5.96283 17.4282 6.141 17.2845 6.2845C17.141 6.42817 16.9628 6.5 16.75 6.5C16.5372 6.5 16.359 6.42817 16.2155 6.2845C16.0718 6.141 16 5.96283 16 5.75V2.55375Z"
      fill="#3E3E3E"
    />
  </svg>
);

export const PersonIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 14V12.6667C10.6667 11.9594 10.3857 11.2811 9.88562 10.781C9.38552 10.281 8.70724 10 8 10H4C3.29276 10 2.61448 10.281 2.11438 10.781C1.61428 11.2811 1.33333 11.9594 1.33333 12.6667V14"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M10.6667 2.08533C11.2385 2.23358 11.7449 2.56751 12.1065 3.03471C12.468 3.50191 12.6641 4.07593 12.6641 4.66667C12.6641 5.25741 12.468 5.83143 12.1065 6.29863C11.7449 6.76582 11.2385 7.09975 10.6667 7.248"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M14.6667 14V12.6667C14.6662 12.0758 14.4696 11.5018 14.1076 11.0349C13.7456 10.5679 13.2388 10.2344 12.6667 10.0867"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6 7.33333C7.47276 7.33333 8.66667 6.13943 8.66667 4.66667C8.66667 3.19391 7.47276 2 6 2C4.52724 2 3.33333 3.19391 3.33333 4.66667C3.33333 6.13943 4.52724 7.33333 6 7.33333Z"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666667 5.99965C0.66662 5.8057 0.708889 5.61407 0.790525 5.43813C0.872161 5.26219 0.991198 5.10618 1.13933 4.98099L5.806 0.981653C6.04666 0.778259 6.35157 0.666667 6.66667 0.666667C6.98176 0.666667 7.28668 0.778259 7.52733 0.981653L12.194 4.98099C12.3421 5.10618 12.4612 5.26219 12.5428 5.43813C12.6244 5.61407 12.6667 5.8057 12.6667 5.99965V11.9997C12.6667 12.3533 12.5262 12.6924 12.2761 12.9425C12.0261 13.1925 11.687 13.333 11.3333 13.333H2C1.64638 13.333 1.30724 13.1925 1.05719 12.9425C0.807142 12.6924 0.666667 12.3533 0.666667 11.9997V5.99965Z"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
